module.exports = __webpack_public_path__ + "static/media/xunta.712bb3da.jpeg";